module.exports = __webpack_public_path__ + "media/images/shopping-cart-bg-gray-3ec3a33f8151d3f877fbb7171b3e9efa.png";